import { FaClock, FaMapMarkerAlt, FaUserTie, FaDollarSign, FaTags, FaBriefcase, FaCalendarAlt, FaPhone, FaUsers, FaEnvelope, FaHourglass, FaHardHat, FaIndustry, FaTools, FaPaintRoller, FaDraftingCompass } from 'react-icons/fa';
import { FaHouse } from 'react-icons/fa6';



// Function to render the appropriate icon based on the name
export const renderIcon = (iconName) => {

  // Convert the name to lowercase
  const lowercaseServiceName = iconName.toLowerCase();

  // Check the lowercase name and return the corresponding icon component
  switch (lowercaseServiceName) {

    /*----- Service Icons -----*/
    case 'general {contracting}':
      return <FaHardHat />; // Hard hat icon

    case 'residential {construction}':
      return <FaHouse />; // House icon

    case 'commercial {construction}':
      return <FaIndustry />; // Factory/Industry icon

    case 'renovation & {remodeling}':
      return <FaTools />; // Tools icon

    case 'interior {design}':
      return <FaPaintRoller />; // Paint roller icon

    case 'structural {engineering}':
      return <FaDraftingCompass />; // Drafting compass icon

    /*----- Page Sidebar -----*/
    case 'date':
    case 'days':
    case 'deadline':
      return <FaCalendarAlt />; // Calendar icon

    case 'timing':
    case 'hours':
    case 'time':
      return <FaClock />; // Clock icon

    case 'duration':
      return <FaHourglass />; // Hourglass icon

    case 'client':
    case 'position':
      return <FaUsers />; // Users icon

    case 'category':
      return <FaTags />; // Tags icon

    case 'location':
      return <FaMapMarkerAlt />; // Location icon

    case 'salary':
    case 'cost':
      return <FaDollarSign />; // Dollar icon

    case 'experience':
      return <FaBriefcase />; // Briefcase icon

    case 'leadarchitect':
      return <FaUserTie />; // Leader icon

    case 'number':
      return <FaPhone />; // Phone icon

    case 'email':
      return <FaEnvelope />; // Email icon

    default:
      return null; // Return null if no matching icon is found
  }

};